if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function(callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function() {
    $.fancybox.defaults.autoFocus = false;

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    //Open Navigation Mobile
    $('#menu-btn-mobile').click(function(event) {
        event.preventDefault();
        $('.burger').addClass('open');
        $('.menu-content').addClass('open');
        $('#booking-section').removeClass('open');
    });

    $('.close-menu').click(function(event) {
        event.preventDefault();
        $('.burger').removeClass('open');
        $('.menu-content').removeClass('open');
    });

    $('.sym-slides').slick({
        arrows: true,
        dots: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 700,
        accessibility: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('.history-slides').slick({
        arrows: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 700,
        accessibility: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('.home-gallery-slides').slick({
        arrows: true,
        dots: false,
        fade: false,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 700,
        accessibility: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '25px',
    });

    $('.responsive-slides').slick({
        arrows: true,
        dots: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 12000,
        speed: 700,
        accessibility: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    fade: false,
                    adaptiveHeight: false,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    fade: false,
                    adaptiveHeight: false
                }
            }
        ]
    });

    $('.specials-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        accessibility: true,
        // variableWidth: true,
        responsive: [{
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: "unslick"
            }
        ]
    });
    $('.reviews-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    /* Press Form */
    let pressbtn = document.getElementById('press_form_toggle');
    if (pressbtn) {
        let theform = document.getElementById('press_form');
        pressbtn.addEventListener('click', (e) => {
            e.preventDefault();
            pressbtn.classList.toggle('active');
            theform.classList.toggle('active');
        })
    };

    if (document.getElementById('terms_btn')) {
        let btnTerms = document.getElementById('terms_btn');
        let termsInfo = document.getElementById('terms_info');
        let termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
        btnTerms.addEventListener('click', function(e) {
            e.preventDefault();
            termsInfo.classList.toggle('open');
            if (!this.classList.contains('active')) {
                this.classList.add('active');
                termsInfo.style.height = termsInfoHeight + 'px';
            } else {
                this.classList.remove('active');
                termsInfo.style.height = '0px';
            }
        });
    }
    if (document.getElementsByClassName('terms-copy').length > 0) {
        let allTermsFancy = document.getElementsByClassName('js-terms');
        let allTermsLength = allTermsFancy.length;
        for (let j = 0; j < allTermsLength; j++) {
            allTermsFancy[j].addEventListener('click', function(e) {
                e.preventDefault();
                let target = this.getAttribute('href').split('#')[1];
                let wrapHeight = document.getElementById(target).getElementsByClassName('wrap')[0].clientHeight;
                if (!document.getElementById(target).classList.contains('open')) {
                    this.classList.add('active');
                    document.getElementById(target).classList.add('open')
                    document.getElementById(target).style.height = wrapHeight + 'px';
                } else {
                    this.classList.remove('active');
                    document.getElementById(target).classList.remove('open');
                    document.getElementById(target).style.height = '0px'
                }
            })
        }
    }

    /**** ADA: aria-labels for booking widget ****/
    const arrivalInput = document.querySelector('.dates #CheckIn');
    const departureInput = document.querySelector('.dates #CheckOut');

    if(arrivalInput && departureInput){
        arrivalInput.setAttribute('aria-label','enter your arrival date')
        departureInput.setAttribute('aria-label','enter your departure date')
    }

    /**** ADA: aria-labels for gallery ****/
    const imageCTA = document.querySelectorAll('#gallerymontage a');
    if (imageCTA) {
        imageCTA.forEach(cta => {
            cta.setAttribute('aria-label' , 'expand to view the photo');
        }) 
    } 

    /**** ADA: Press form cta label & aria-label ****/
    const pressSubmitCTA = document.getElementById('press_form_toggle');
    if(pressSubmitCTA) {
        pressSubmitCTA.setAttribute('aria-label' , 'submit media form')
        pressSubmitCTA.textContent = 'submit media form';
    }

    document.addEventListener("readystatechange", () => {
        document.readyState === "complete" && document.documentElement.style.setProperty(
            "--header-height",
            document.getElementsByTagName('header')[0].getBoundingClientRect().height + 'px'
        );
    });

})();